import React from 'react';
import {DialogStyled} from "./modalComponent";
import {ModalIds, useModal} from "../../contexts/ModalContext";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import {
    ButtonStyled,
    HrLine,
    OnlineRegistrationBox
} from "../styledComponent/styledComponents";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import {useMediaQuery} from "@mui/material";
import {useGetPaymentFeesQuery, useSendPaymentFeesInfoMutation} from "../../features/apiSlice/payment-get-fees";
import {toast} from "react-toastify";
import { useUser } from '../../features/user/userSlice';
import { useSelector } from 'react-redux';

const OnlineRegistrationModal = () => {
    const {handleClose, modalId} = useModal()
    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');
    const userApiStatus = useSelector(useUser);
    const {data: paymentGetFees, error, isLoading} = useGetPaymentFeesQuery(null,{
        skip: (userApiStatus?.data?.user?.status !== "accredit-plan" && userApiStatus?.data?.user?.status !== "details") // If the user's step is "accredit-plan and details" the query will be executed
    })
    const [makeRequest, {isLoading: redirectDataIsLoading}] = useSendPaymentFeesInfoMutation()

    function handleRegister() {
        handleClose()
        makeRequest({
            accreditation: "accreditation",
            bank: paymentGetFees?.data?.accreditation?.banks[0]
        }).unwrap()
            .then(response => window.location.href = response?.data?.link)
            .catch(rejected => toast.error(rejected.data?.message))
    }


    return (
        <DialogStyled open={modalId === ModalIds.ONLINE_REGISTRATION} onClose={handleClose}
                      width={!matches ? "600px" : "330px"}>
            <Stack direction={'row'} width={"100%"} height={70} justifyContent={"space-between"} px={3}
                   alignItems={"center"}>
                <Typography fontSize={16} color={'tertiary.main'} fontWeight={'bold'}>
                    ثبت‌ نام:
                </Typography>
                <IconButton size={'small'} color={"fourth"} onClick={handleClose}>
                    <ClearIcon/>
                </IconButton>
            </Stack>
            <HrLine/>

            <OnlineRegistrationBox>
                <Typography fontSize={16} color={"tertiary.main"} fontWeight={'bold'} py={0.75}>ثبت‌ نام
                    آنلاین</Typography>
                <Typography fontSize={14} color={"#464646"}>
                    هزینه ثبت
                    نام: {paymentGetFees?.data?.accreditation?.fee + paymentGetFees?.data?.verification?.fee} تومان
                    ( شامل هزینه اعتبارسنجی، احراز هویت و... می‌باشد. )
                </Typography>
            </OnlineRegistrationBox>
            <Stack alignItems={'center'} pb={2} pt={4}>
                <ButtonStyled
                    onClick={handleRegister}
                    type={'button'}
                    width={152} height={44} startIcon={<PersonAddAltIcon sx={{marginBottom: "3px"}}/>}
                    variant="contained">
                    ثبت نام
                </ButtonStyled>
            </Stack>
        </DialogStyled>
    );
};

export default OnlineRegistrationModal;